import { defaults } from 'axios';

var selectedApiUrl = 'prod';

const apiUrlDev = 'https://api.lead-funnel.myc3.dev/api/';
const apiUrlProd = 'https://api.lead-funnel.myc3.dev/api/';

const assetsUrlDev = 'https://assets.my-lead-funnel.de/';
const assetsUrlProd = 'https://assets.my-lead-funnel.de/';

const debugData = {"id":6,"name":"Eurorastpark","survey":{"id":8,"name":"Recruiting","informationType":29,"phonenumber":"","email":null,"projectId":6,"pages":[{"id":31,"title":"Für welchen Beruf möchten Sie sich gerne bewerben?","data":"","elementType":1,"surveyId":8,"elements":[{"id":97,"data":"Küche","icon":null,"pageId":31},{"id":98,"data":"Service","icon":null,"pageId":31},{"id":99,"data":"Technik","icon":null,"pageId":31}]},{"id":32,"title":"Für welchen Standort möchten Sie sich bewerben?","data":"","elementType":1,"surveyId":8,"elements":[{"id":100,"data":"Hamm-Uentrop/Lippetal","icon":null,"pageId":32},{"id":101,"data":"Irxleben/Hohenwarsleben","icon":null,"pageId":32},{"id":102,"data":"Theeßen","icon":null,"pageId":32},{"id":103,"data":"Regensburg-Ost","icon":null,"pageId":32},{"id":104,"data":"Hengersberg","icon":null,"pageId":32},{"id":105,"data":"Achern","icon":null,"pageId":32},{"id":106,"data":"Crailsheim/Satteldorf","icon":null,"pageId":32},{"id":107,"data":"Guxhagen","icon":null,"pageId":32},{"id":108,"data":"Dreieck Fulda / Eichenzell","icon":null,"pageId":32},{"id":109,"data":"Burgau / Jettingen-Scheppach","icon":null,"pageId":32},{"id":110,"data":"Münchberg-Nord","icon":null,"pageId":32},{"id":111,"data":"Himmelkron","icon":null,"pageId":32},{"id":112,"data":"Pfaffenhofen / Schweitenkirchen","icon":null,"pageId":32},{"id":113,"data":"Waldlaubersheim","icon":null,"pageId":32},{"id":114,"data":"Werneck","icon":null,"pageId":32},{"id":115,"data":"Knetzgau","icon":null,"pageId":32},{"id":116,"data":"Aichstetten","icon":null,"pageId":32},{"id":117,"data":"Asbach-Bäumenheim","icon":null,"pageId":32}]}],"results":[]}};

function setApiUrl() {
    if (selectedApiUrl == 'dev')
        defaults.baseURL = apiUrlDev;
    else if (selectedApiUrl == 'prod')
        defaults.baseURL = apiUrlProd;
    else if (process.env.NODE_ENV == 'development')
        defaults.baseURL = apiUrlDev;
    else
        defaults.baseURL = apiUrlProd;
}

function getAssetsUrl() {
    if (selectedApiUrl == 'dev') 
        return assetsUrlDev;
    else if (selectedApiUrl == 'prod') 
        return assetsUrlProd;
    else if (process.env.NODE_ENV == 'development') 
        return assetsUrlDev;
    else 
        return assetsUrlProd;
}

export { setApiUrl, getAssetsUrl, debugData };